/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_PlayInputs */



/**
* | output |
* | --- |
* | "Play" |
*
* @param {Options_Pedal_Action_PlayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_play = /** @type {((inputs?: Options_Pedal_Action_PlayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_PlayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spielen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Играть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("玩")
	if (locale === "ja") return /** @type {LocalizedString} */ ("遊ぶ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Jogar")
	return /** @type {LocalizedString} */ ("Play")
});